import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const pageNotFoundLogo = "/assets/images/X.png";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <img src={pageNotFoundLogo} alt="" className="h-16 w-16" />
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you are looking for does not exist.
      </p>
      <Button onClick={() => navigate("/")}>Back to home</Button>
    </div>
  );
};

export default PageNotFound;
